export default __webpack_public_path__ + "static/media/tier25.8ad5ac94.png";